/* Provides a warning message wrapped in a warning box bordered to make it stand out */

import React from "react";
import { useTheme } from "styled-components";
import { ThemedIcon, ThemedSpan } from "../utilities";

const WarningMessageBox = ({ children, title = "Attention!" }) => {
    const theme = useTheme();
    return (
        <div className="p-3" style={{ border: '1px', borderStyle: 'solid', borderColor: theme?.danger ?? '#000' }}>
            <div className="mb-2">
                <ThemedIcon icon="fa-triangle-exclamation" variant="danger" className="me-2" size="lg" />
                <ThemedSpan variant="danger">{title}</ThemedSpan>
            </div>
            <div className="fs-6" style={{ color: theme?.danger ?? '#000' }}>
                {children}
            </div>
        </div>
    );
};

export default WarningMessageBox;